import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { TeamAnnouncements } from '../components/TeamAnnouncements';

export const TeamAnnouncementsProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <TeamAnnouncements {...data} />
        </Provider>
    );
};

export default TeamAnnouncementsProvider;

TeamAnnouncementsProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
